/**
 * B110040 担当者別目標データ EXCEL 取込
 */

import { Box } from "@mui/material";
import { B110040Import, catchRestError } from "clients/rest";
import {
  msgState,
  SFileButton,
  SFileField,
  SFrame,
  SNormalButton,
  SText,
  STextArea,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { outputText } from "services";

// 呼び出し定義
type Props = Partial<{}>;

// フィールド定義
type Fields = Partial<{
  filedropArea: File;
  outputText: string;
}>;

// フィールド初期値
const defaultFields: Fields = {
  filedropArea: undefined,
  outputText: "",
};

// タイトル
const title = "担当者別目標設定";

// 取込結果ファイル名
const reportFileName = `${title}取込結果.txt`;

// B110040 担当者別目標データ EXCEL 取込
export const B110040 = (props: Props) => {
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 画面遷移
  const navigate = useNavigate();

  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // フォーム
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // 実行ボタン活性制御
  const disabledUploadButton = () =>
    methods.watch("filedropArea") === undefined;

  // レポートボタン活性制御
  const disabledReportButton = () => methods.watch("outputText") === "";

  // 実行
  const handleClickUploadButton = () => {
    // フィールド取得
    const fields = methods.getValues();

    // 開始メッセージを設定
    methods.setValue("outputText", getClientMessage("B110040_001"));

    if (!fields.filedropArea) return;

    // 取込
    B110040Import({ excelFileData: fields.filedropArea })
      .then((value) => {
        // 取込結果表示
        setMsg("");
        methods.resetField("filedropArea");
        methods.setValue("outputText", value.data.torikomikeka);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        methods.resetField("outputText");
      });
  };

  // 結果レポート出力
  const handleClickReportButton = () => {
    setMsg("");
    // EXCEL 取込結果取得
    const text = methods.getValues().outputText;
    if (!text) return;
    // レポート出力
    outputText(text, reportFileName);
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame title={title} gridTemplateColumns="1fr 10rem" m={2} width={1080}>
        <Box m={1} gridColumn="span 2">
          <SFileField
            name="filedropArea"
            label="取り込む担当者別目標EXCELファイル"
            type="excel"
            height="12rem"
          />
        </Box>
        <SNormalButton
          label={labels.buttons.execute}
          align="right"
          gridColumn="2"
          onClick={handleClickUploadButton}
          disabled={disabledUploadButton()}
        />
        <SText align="left" gridColumn="span 2">
          担当者別目標データEXCEL取込結果
        </SText>
        <Box m={1} gridColumn="span 2">
          <STextArea name="outputText" height="16rem" disabled />
        </Box>
        <SFileButton
          label={labels.buttons.resultReport}
          align="right"
          gridColumn="2"
          onClick={handleClickReportButton}
          disabled={disabledReportButton()}
        />
      </SFrame>
    </FormProvider>
  );
};
